export default "__VITE_ASSET__BTZHEUSc__"